module.exports = __webpack_public_path__ + "img/program1.f689f396.png";